import SectionLabel from "../../../app/universalComponents/SectionLabel";
import Alert from "../../../app/universalComponents/Alert";
import ErrorState from "../../../app/universalComponents/ErrorState";

export default function KPICards({ eventStatus, totals, today }) {
  if (!totals || !today) {
    return null;
  }

  const revenue = Number(totals.revenue ?? 0);
  const todayRevenue = Number(today.revenue ?? 0);
  const sold = Number(totals.sold ?? 0);
  const todaySold = Number(today.sold ?? 0);

  return (
    <>
      <article className="col-span-6 flex flex-col md:col-span-2">
        <SectionLabel>Revenue</SectionLabel>

        <div className="flex flex-1 flex-col rounded-sm border p-4">
          <h1 className="flex items-end gap-2 text-4xl font-semibold">
            €{revenue.toFixed(2)}
            <span className="truncate text-lg font-normal">generated</span>
          </h1>

          {eventStatus === "published" && (
            <Alert tone="positive" className="mt-2 w-fit rounded">
              €{todayRevenue.toFixed(2)} today
            </Alert>
          )}
        </div>
      </article>

      <article className="col-span-6 flex flex-col md:col-span-2">
        <SectionLabel>Tickets</SectionLabel>

        <div className="flex flex-1 flex-col rounded-sm border p-4">
          <h1 className="flex items-end gap-2 text-4xl font-semibold">
            {sold}
            <span className="truncate text-lg font-normal">
              {sold === 1 ? "ticket sold" : "tickets sold"}
            </span>
          </h1>

          {eventStatus === "published" && (
            <Alert tone="positive" className="mt-2 w-fit rounded">
              {todaySold} today
            </Alert>
          )}
        </div>
      </article>

      <article className="col-span-6 flex flex-col md:col-span-2">
        <SectionLabel>Attendance</SectionLabel>

        <div className="flex flex-1 flex-col rounded-sm border p-4">
          {totals.checked_in != null ? (
            <>
              <h1 className="flex items-end gap-2 text-4xl font-semibold">
                {totals.checked_in}
                <span className="truncate text-lg font-normal">
                  checked in
                </span>
              </h1>

              <Alert
                tone={
                  totals.attendance_rate >= 75
                    ? "positive"
                    : totals.attendance_rate >= 25
                      ? "neutral"
                      : "negative"
                }
                className="mt-2 w-fit rounded"
              >
                {totals.attendance_rate ?? 0}% attendance rate
              </Alert>
            </>
          ) : (
            <div className="flex flex-1 items-center justify-center">
              <ErrorState>
                Check back after the event has started.
              </ErrorState>
            </div>
          )}
        </div>
      </article>
    </>
  );
}
